import axios from 'axios'

export default {
  fileUpload (payload) {
    return axios.post('/api/file-upload', payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  exportFile (filter, payload) {
    const url = filter ? `/api/export-products/${filter}` : '/api/export-products'
    return axios.post(url, payload) // Pass checkboxes as data
  },

  fetchColumns () {
    return axios.get('/api/fetch-columns')
  },
    updateStockColumn (payload) {
    return axios.post('/api/update-product-column', payload)
  },
    updateStockColumnOrder (payload) {
    return axios.post('/api/update-product-column-order', payload)
  },

  fetchStock (search, sort_by, sort_order, page, limit, filter_criteria, logical_operators) {
    return axios.get(`/api/stock?search=${search}&sort_by=${sort_by}&sort_order=${sort_order}&page=${page}&limit=${limit}&filter_criteria=${filter_criteria}&logical_operators=${logical_operators}`)
  },

  bulkUpdate (payload) {
    return axios.put('/api/stock/bulk-update', payload)
  },

  createProduct (payload) {
    return axios.post('/api/admin/products', payload)
  },

  deleteProduct (id) {
    return axios.delete(`/api/admin/products/${id}`)
  },

  bulkDelete(selectedItems) {
    return axios.delete('/api/stock/bulk-delete', {
        data: selectedItems
    })
  },
  fetchFilter () {
    return axios.get('/api/filter-criteria')
  },
  showFilter (id) {
    return axios.get('/api/filter-criteria/' + id)
  },

  createFilter (payload) {
    return axios.post('/api/filter-criteria', payload)
  },

  updateFilter (id, payload) {
    return axios.put('/api/filter-criteria/' + id, payload)
  },
  deleteFilter (payload) {
    return axios.delete('/api/filter-records/bulk-delete', { data: payload })
  },
  updateReorderFilter (payload) {
    return axios.patch('/api/reorder-filter-update', payload)
  },
  uploadAdminImages (payload) {
    return axios.post('/api/images/bulk-upload', payload)
  },
  getAdminImagery (params) {
    return axios.get('/api/images/list-all', { params })
  },
  getAdminManagementImagery (params) {
    return axios.get('/api/images/manage-list', { params })
  },
  getImageDesignNumbers () {
    return axios.get('/api/images/design-numbers')
  },
  adminImageryDelete (payload) {
    return axios.delete('/api/images/delete', { data: payload })
  },
  adminImageryManagementUpdate (payload) {
    return axios.post('/api/images/update-metadata', payload)
  },
  adminImageryUpdateDesign (payload) {
    return axios.post('/api/images/update-design', payload)
  },
  fetchProductAttributes() {
    return axios.get('/api/stock/attributes')
  },
  fetchFutureATSDetails(productId, sizeId) {
    return axios.get(`/api/stock/future-ats/${productId}`, {
        params: { size_id: sizeId }
    });
  },
  exportProducts (payload) {
    return axios.post('/api/export-products', payload)
  }
}
